import type { ListGroupTiersParams } from '../types/group-tiers'

/**
 * Centralized query keys for group tiers (TanStack Query).
 * Use for every queryKey, invalidateQueries, setQueryData, and getQueryData.
 */
export const groupTiersQueryKeys = {
  all: ['group-tiers'] as const,
  list: (groupId: string, locationId: string, params?: ListGroupTiersParams) =>
    ['group-tiers', groupId, locationId, 'list', params] as const,
  accessOptions: (groupId: string, locationId: string) => ['group-tiers', groupId, locationId, 'access-options'] as const,
  /** Member-facing join catalogue (shared by JoinPlansView + Subscribe CTA). */
  plans: (groupId: string, locationId: string) => ['group-tiers', groupId, locationId, 'plans'] as const,
} as const
